export default {
      id: "oc-dashboard-title-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-dashboard-title",
      toString: function () {
        return this.url;
      }
    }